import React from "react";
import MainBody from "../../../components/MainBody/MainBody";
import { cn } from "../../../lib/utils";
import HtmlContent from "../../../components/HTMLContent";

const ExpandFAQ = ({ answerData }) => {
  return (
    <MainBody
      search={false}
      expandList={true}
      loading={false}
      actionContent={false}
      innerBody={true}
    >
      <div className={cn("text-sm")}>
        <HtmlContent html={answerData} />
      </div>
    </MainBody>
  );
};

export default ExpandFAQ;
